var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('terms-dialog', {
    on: {
      "isLoaded": _vm.setTermsList,
      "input": function input(value) {
        return _vm.$emit('input', value);
      },
      "isValid": function isValid(_isValid) {
        return _vm.$emit('isValid', _isValid);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          isValid = _ref.isValid;
        return [_c('v-sheet', _vm._g({
          attrs: {
            "color": "mt-20 mt-lg-42"
          }
        }, on), [_c('v-checkbox', {
          staticClass: "mb-12",
          attrs: {
            "label": "전체 동의하기",
            "hide-details": "",
            "color": "primary",
            "on-icon": "mdi-checkbox-outline",
            "value": isValid,
            "readonly": ""
          }
        }), _c('v-card', {
          staticClass: "min-h-80px",
          attrs: {
            "outlined": "",
            "rounded": "lg"
          }
        }, [_c('div', {
          staticClass: "pa-12 pa-md-20"
        }, _vm._l(_vm.termsList, function (terms) {
          return _c('v-checkbox', {
            key: terms._id,
            attrs: {
              "label": "[".concat(terms.necessary ? '필수' : '선택', "]").concat(terms.subject, "\uC5D0 \uB3D9\uC758"),
              "value": _vm.selected.includes(terms._id),
              "hide-details": "",
              "readonly": ""
            }
          });
        }), 1)])], 1)];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }